import { SITE } from '@/app/constants';
import type { CardType } from './types';

export const LOGIN_ERROR_INTL_PREFIX = 'login.error.';

// 账号 + 验证码同屏（IdentityCodeLoginCard），不再有独立的验证码页：国内手机号单步，海外选完方式后邮箱单步
export const CARD_SERIES_CONFIG = (SITE === 'china' ? ['PHONE'] : ['LOGIN', 'EMAIL']) as CardType[];

/**
 * 有效的产品页面来源列表
 * 用于判断首次登录时是否需要上报 login_page_exposure 事件
 */
export const VALID_FROM_PAGES = [
  'image to video',
  'text to video',
  'image generator',
  'reference to video',
  'vidu q3',
  'vidu q3 vs seedance 2-0 vs kling 3-0',
] as const;
